import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Input,
  Modal,
  Alert,
  Typography,
  Row,
  Col,
  Form,
} from "antd";
import { ArrowLeftOutlined, ScanOutlined } from "@ant-design/icons";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";

const { Text, Title } = Typography;

const BinBulkScan = ({ userData }) => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setError("");
    setIsModalOpen(true);
  };

  const handleSubmit = (values) => {
    const binId = values.binId?.trim();

    if (!binId) {
      setError("Please provide a valid scanned data or enter it manually");
      return;
    }

    try {
      setError("");
      setIsLoading(true);
      navigate(`/dc-bulk-bin-outward?binId=${encodeURIComponent(binId)}`);
    } catch (error) {
      console.error(error);
      setError("An error occurred while processing the bin data");
      setIsLoading(false);
    }
  };

  const handleScan = (result) => {
    if (!result) {
      setError("No valid barcode detected. Please try again.");
      return;
    }

    setIsModalOpen(false);
    handleSubmit({ binId: result });
  };

  const handleScanError = (error) => {
    setError("Error accessing camera. Please try manual input or check camera permissions.");
    console.error(error);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 24,
          gap: 10,
        }}
      >
        <ArrowLeftOutlined
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer", fontSize: 16 }}
        />
        <Title level={5} style={{ margin: 0 }}>
          Scan to Add Bulk Outward
        </Title>
      </div>

      <div
        style={{
          minHeight: "420px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row gutter={[32, 32]} style={{ maxWidth: 900, width: "100%" }}>
          <Col xs={24} md={12}>
            <div
              className="dashboard-stat-card bg-card-blue"
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleTagClick}
            >
              <div
                className="dashboard-stat-card-inner"
                style={{
                  width: "100%",
                  textAlign: "center",
                  gap: 10,
                  justifyContent: "center",
                }}
              >
                <ScanOutlined style={{ fontSize: 28 }} />
                <div className="dashboard-stat-value">Scan Bin</div>
                <Text style={{ color: "#475569" }}>
                  Click here to open barcode scanner
                </Text>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: 16,
                padding: 24,
                boxShadow: "0 6px 20px rgba(15, 23, 42, 0.06)",
                height: "100%",
              }}
            >
              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16, borderRadius: 10 }}
                />
              )}

              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <Text strong type="secondary">
                  Or enter Bin ID manually
                </Text>
              </div>

              <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item
                  name="binId"
                  label="Enter Bin ID"
                  rules={[
                    {
                      required: true,
                      message: "Bin ID cannot be empty. Please provide a valid ID.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Enter Bin ID"
                    style={{ textAlign: "center", borderRadius: 10 }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    block
                    loading={isLoading}
                    className="primary-btn"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        title="Scan Bar Code"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default BinBulkScan;